import React from 'react';
import styled from 'styled-components';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import TextField from '@components/TextFieldCaseSetting';
import IconButton from '@material-ui/core/IconButton';

export const Container = styled.div`
  pointer-events: ${({ preview }) => (preview ? 'none' : 'auto')};
  height: 100%;
`;

export const SubcomponentContainer = styled.div`
  padding: 15px 10px;
  height: 100%;
`;

export const WidgetContainer = styled.div`
  padding-top: ${({ isEconomicUnit }) => (isEconomicUnit ? '0px' : '15px')};
  height: 100%;
`;

export const ContentWrapper = styled.div`
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
  height: 100%;
  padding-top: 10px;
`;

export const TopHeaderContainer = styled.div`
  height: 56px;
  padding-left: 20px;
  font-size: 28px;
  font-weight: bold;
  font-family: Roboto, sans-serif;
`;

export const ImprovementTopHeaderContainer = styled.div`
  height: 56px;
  padding-left: 20px;
  font-size: 28px;
  font-weight: bold;
  font-family: Roboto, sans-serif;
  display: flex;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
  height: 56px;
  font-family: Roboto, sans-serif;
  visibility: ${({ preview }) => (preview ? 'hidden' : 'visible')};
`;

export const SideControlContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  visibility: ${({ preview }) => (preview ? 'hidden' : 'visible')};
`;

export const Divider = styled.hr`
  color: #c2d92b;
  background-color: #c2d92b;
  height: 4px;
  margin: 0 ${({ margin }) => margin || '10px'};
`;

export const Title = styled.h4`
  flex: ${({ flex }) => flex || 1};
  font-family: Roboto, sans-serif;
  visibility: visible;
  font-size: 24px;
  font-weight: 500;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.87);
`;

export const HotKey = styled.p`
  &&&&&&&&& {
    align-self: center;
    color: #aaa;
    font-size: 10px;
    margin-right: 10px;
  }
`;

export const StyledButton = styled(Button)`
  &&& {
    font-weight: bold;
    cursor: ${({ preview }) => !preview && 'pointer'};
    background-color: #36449d;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.24);
    color: #fff;
    min-width: 90px;
  }
`;

const MuiFab = styled(Fab)`
  && {
    z-index: 7;
    margin-left: 10px;
    width: ${({ size }) => (size === 'small' ? '35px' : '56px')};
    height: ${({ size }) => (size === 'small' ? '20px' : '56px')};
    background-color: #36449d;
    cursor: ${({ preview }) => !preview && 'pointer'};
  }
`;

export const AddButton = props => (
  <MuiFab aria-label="Add" color="primary" {...props}>
    <AddIcon />
  </MuiFab>
);

export const TableContainer = styled.div`
  height: ${({ height }) => height || '200px'};
  margin: 10px 4px 4px 4px;
  filter: ${({ preview }) => (preview ? 'blur(2px)' : null)};
  pointer-events: ${({ preview }) => (preview ? 'none' : 'auto')};

  & .ag-rich-select .ag-rich-select-list {
    width: ${({ wideSelect }) =>
      wideSelect ? '400px !important' : '200px !important'};
  }
`;

export const StyledIcon = styled.i`
  margin-left: 7px;
  font-size: 14px;
  cursor: pointer;
`;

export const StyledPrimaryIcon = styled.i`
  margin-left: 7px;
  font-size: 14px;
  cursor: pointer;
  color: ${({ primary }) => (primary === 'Yes' ? '#46be8a' : '#00000020')};
`;

export const StyledSelect = styled(({ ...other }) => (
  <Select {...other} inputProps={{ classes: { outlined: 'outlined' } }} />
))`
  padding-top: 8px;
  padding-bottom: 8px;

  & .outlined {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const AddCommentTextField = styled(({ ...other }) => (
  <TextField
    {...other}
    InputLabelProps={{
      classes: {
        root: 'root',
        focused: 'focused',
        shrink: 'shrink',
      },
    }}
  />
))`
  flex: 1;
  padding-left: 5px;

  && .shrink {
    top: 0;
  }

  & .root {
    top: -10px;
  }

  && .focused {
    top: 0;
  }
`;

export const SearchTextField = styled(({ ...other }) => (
  <TextField
    {...other}
    InputLabelProps={{
      classes: {
        root: 'root',
        focused: 'focused',
        shrink: 'shrink',
      },
    }}
    InputProps={{
      style: { padding: '10px 14px' },
    }}
    inputProps={{
      style: { padding: '0' },
    }}
  />
))`
  && .shrink {
    top: 0;
  }

  & .root {
    top: -10px;
  }

  && .focused {
    color: #b5cd3a;
  }
`;

export const FullScreenButton = styled(IconButton)`
  && {
    width: 30px;
    height: 30px;
    padding: 0;
  }
`;

export const AddCommentContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 4px;
  margin-top: 6px;
  padding-right: 10px;
  ${'' /* height: 90px; */}
  align-items: center;
  filter: ${({ preview }) => (preview ? 'blur(2px)' : null)};

  & div {
    width: 100%;
    margin: 0 10px 0 0 !important;
  }

  & button {
    margin-right: 5px;
  }
`;
